import { render } from "./MyAccountRoomsCardsPage.vue?vue&type=template&id=6b5ea08e&scoped=true"
import script from "./MyAccountRoomsCardsPage.vue?vue&type=script&lang=js"
export * from "./MyAccountRoomsCardsPage.vue?vue&type=script&lang=js"

import "./MyAccountRoomsCardsPage.vue?vue&type=style&index=0&id=6b5ea08e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5ea08e"]])

export default __exports__